import React from "react";

function IconBuyerDemand() {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19">
      <path d="m10.5 6.337 2.188-1.875 2.188 1.875v2.5H10.5v-2.5ZM2.625 7.744c0-.604.49-1.094 1.094-1.094h2.187C6.51 6.65 7 7.14 7 7.744V8.4a.437.437 0 0 1-.437.437h-3.5a.437.437 0 0 1-.438-.437V7.744Z" />
      <path d="M3.719 5.556a1.094 1.094 0 1 1 2.187 0 1.094 1.094 0 0 1-2.187 0Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.969 10.15c0-.363.294-.656.656-.656h12.25a.656.656 0 0 1 0 1.312H2.626a.656.656 0 0 1-.656-.656Z"
      />
      <path d="M8.333 11.037a.438.438 0 0 1 .835 0l1.098 3.488H7.235l1.098-3.488Z" />
    </svg>
  );
}

export default IconBuyerDemand;
